import MobileDetect from 'mobile-detect'
import Data from '@/data/data.js'
import Bus from '@/bus/BusEvent.js'

class Store {
    constructor() {
        this.state = {
            isTweening: false,
            fontLoaded: false,
            transitionsLoaded: false,
            dataLoaded: false,
            appLoaded: false,
            level: 0,
            route:'',
            notFound: false,
            loaded: 0,
            cursorLocked: false,
            isHovering : false,
            cursorHover: false,
            lineHeight: 120,
            init: true,
            scrollPosition: 0,
            scrollHeight: 0,
            scrollDistance: 0,
            scrollRatio: 0,
            mouse: {
                x: 0,
                y: 0
            },
            cursorText: '',
            currentDirector: null,
            // showDirector: false,
            currentNews: null,
            // showNews: false,
            changeBrowser: false
        },
        
        this.data = Data;
        this.direction = 1;
        this.lastScroll = window.scrollY || window.pageYOffset;
        this.scroll = window.scrollY || window.pageYOffset;

        
        this.md = new MobileDetect(window.navigator.userAgent);
        
        this.Safari = this.md.version("Safari")

        this.isMobile = !!this.md.mobile();
        this.isTablet = !!this.md.tablet();
        
        this.isDesktop = !this.isMobile && !this.isTablet;
        this.isTouch = ('ontouchstart' in window) /*|| (navigator.maxTouchPoints > 0)*/ || (navigator.msMaxTouchPoints > 0);
        
        this.isIE = (/*@cc_on!@*/false || !!document.documentMode || /Edge/.test(navigator.userAgent))
        // this.isFirefoxMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0 && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

        this._onDataLoaded = this.onDataLoaded.bind(this);
        this._onResize = this.onResize.bind(this);
        this._onClick = this.onClick.bind(this);
        this._onScroll = this.onScroll.bind(this);

        this.onResize();
        this.setEvents();

        if (this.isTouch) {
            document.querySelector('html').classList.add('isTouch');
            if(this.isDesktop && this.width < 1500) {
                this.isDesktop = false 
                this.isTablet = true
                this.isMobile = true
            }
        }
    }
    
    setEvents(){
        Bus.$on('data-loaded', this._onDataLoaded );
        document.addEventListener("click", this._onClick)
        window.addEventListener('resize', this._onResize);
        window.addEventListener('scroll', this._onScroll);
    }
    
    removeEvents(){
        Bus.$remove('data-loaded', this._onDataLoaded);
        document.removeEventListener("click", this._onClick)
        window.remvoeEventListener('resize', this._onResize);
        window.removeEventListener('scroll', this._onScroll);
    }

    onClick(){
        Bus.$emit('click');
    }

    onScroll(e){
        e.preventDefault()
        if ( !this.state.scrollEnable ) return;
        
        if ( (window.scrollY || window.pageYOffset) < this.lastScroll ){
            this.direction = -1;
        }else{
            this.direction = 1;
        }
        this.lastScroll = this.scroll;
        this.scroll = window.scrollY || window.pageYOffset;

        Bus.$emit('scroll');
    }

    onResize(){
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        this.isSmall = 767 >= this.width;
        this.isMedium = 1024 >= this.width && !this.isSmall;

        Bus.$emit('resize');
    }

    onDataLoaded(){;
        this.data = Data.data;
        this.state.dataLoaded = true;
    }
    

    destroy(){
        removeEvents();
    }
}

let store = new Store();

export default store